import { useState } from 'react';
import { record } from "@solimat/solimat-web-endpoint";

type StatusGetInfoSolicitudGastosTransporte = {
  status: number | null;
  statusText: string | null;
};

const getBackendMessage = (err: any) => {
  const responseData = err?.response?.data;

  return (
    (typeof responseData === "string" ? responseData : null) ||
    responseData?.response ||
    responseData?.message ||
    err?.response?.statusText ||
    err?.message ||
    "Error"
  );
};

const useGetInfoSolicitudGastosTransporte = () => {
  const [loadingGetInfoSolicitudGastosTransporte, setLoadingGetInfoSolicitudGastosTransporte] = useState(false);
  const [successGetInfoSolicitudGastosTransporte, setSuccessGetInfoSolicitudGastosTransporte] = useState(false);
  const [errorGetInfoSolicitudGastosTransporte, setErrorGetInfoSolicitudGastosTransporte] = useState<any>(null);
  const [dataGetInfoSolicitudGastosTransporte, setDataGetInfoSolicitudGastosTransporte] = useState<any>(null);
  const [statusGetInfoSolicitudGastosTransporte, setStatusGetInfoSolicitudGastosTransporte] =
    useState<StatusGetInfoSolicitudGastosTransporte>({
      status: null,
      statusText: null
    });

  const BASE_URL = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_PATH || "";
  const FUNCTIONS_KEY = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_KEY || "";
  const apiRecord = new record.RecordService(BASE_URL, FUNCTIONS_KEY);

  const getInfoSolicitudGastosTransporte = async (
    userId: string,
    expedienteId: string | number | null = null,
    _cb?: (data: any) => void
  ) => {
    setLoadingGetInfoSolicitudGastosTransporte(true);
    setSuccessGetInfoSolicitudGastosTransporte(false);
    setErrorGetInfoSolicitudGastosTransporte(null);

    try {
      void expedienteId;
      const res = await apiRecord.getInfoSolicitudGastosContingenciaProfesionalTransporte(userId);

      setStatusGetInfoSolicitudGastosTransporte({
        status: res.status,
        statusText: res.statusText ?? res.response ?? null
      });

      setSuccessGetInfoSolicitudGastosTransporte(true);
      setDataGetInfoSolicitudGastosTransporte(res.data);
      _cb?.(res.data);

      return res.data;
    } catch (err: any) {
      const backendMessage = getBackendMessage(err);

      setStatusGetInfoSolicitudGastosTransporte({
        status: err?.response?.status || 500,
        statusText: backendMessage
      });

      setErrorGetInfoSolicitudGastosTransporte(err);
      console.error("Error en getInfoSolicitudGastosTransporte:", err);

      throw err;
    } finally {
      setLoadingGetInfoSolicitudGastosTransporte(false);
    }
  };

  return {
    getInfoSolicitudGastosTransporte,
    loadingGetInfoSolicitudGastosTransporte,
    successGetInfoSolicitudGastosTransporte,
    errorGetInfoSolicitudGastosTransporte,
    dataGetInfoSolicitudGastosTransporte,
    statusGetInfoSolicitudGastosTransporte
  };
};

export default useGetInfoSolicitudGastosTransporte;
